/* FLICK-S Easter-Egg Minigame: "Booster Catch"
   Selbst-enthaltenes Spiel fuer die Passwortseite.
   Trigger: Klick auf Logo ODER den Floating-Button.
   Leaderboard: localStorage (pro Geraet). Top-5 -> Gutschein-Formular (E-Mail).
   ---
   E-MAIL-VERSAND: Top-5-Einreichungen werden ueber das NATIVE Shopify-
   Kontaktformular (/contact) verschickt -> du bekommst eine echte E-Mail
   an deine Shop-Benachrichtigungs-Adresse, mit Leaderboard-Name, Score,
   Platzierung und Spieler-E-Mail. Kein Extra-Dienst noetig.
   Hinweis: Der /contact-Versand funktioniert, sobald der Shop LIVE ist
   (ohne Passwortschutz). Solange die Seite passwortgeschuetzt ist, greift
   der mailto-Fallback + lokale Sicherung (localStorage 'flicks_submissions'). */
(function () {
  "use strict";
  // >>> HIER Formspree-URL eintragen (kostenlos auf formspree.io), dann siehst du
  //     ALLE Eintraege (Username, E-Mail, Score) im Formspree-Dashboard + Mail pro Eintrag.
  //     Funktioniert auch waehrend die Seite noch passwortgeschuetzt ist.
  var FORM_ENDPOINT = "https://formspree.io/f/mgogkwol"; // FLICK-S Gewinnspiel Booster Catch
  var FALLBACK_EMAIL = "epicphilipde@gmail.com";
  var LB_KEY = "flicks_leaderboard_v1";
  var MAX_STORE = 5000; // hoher Sicherheits-Deckel, in der Praxis unbegrenzt (kein Top-10/15/25-Cutoff mehr)
  // Globales Leaderboard via JSONBin (nur Access-Key, NICHT Master-Key)
  var BIN_ID = "6a5b019cda38895dfe6dd1d9";
  var BIN_KEY = "$2a$10$hE16D8XvnksQfDVwtnyPEuTAw8v9vHZ40KNP1pN2RJoPVQZzaQuj2";
  var BIN_URL = "https://api.jsonbin.io/v3/b/" + BIN_ID;
  var BRAND = "#800200", BRAND_DK = "#3d0100", BRAND_LT = "#f9afae", GOLD = "#f6d55c";

  /* Gewinnverteilung Top 1-5 (Philip, 2026-08-17). Bei Aenderung der Preise: NUR hier anpassen,
     wird sowohl im Start-Screen (Preis-Liste) als auch im Live-Rang-Hinweis waehrend/nach dem
     Spiel automatisch verwendet - keine doppelte Pflege an mehreren Stellen noetig. */
  var PRIZES = [
    "3x 151 Einzelbooster (Japanisch) + 50€ Gutschein",
    "35€ Gutschein",
    "20€ Gutschein",
    "15€ Gutschein",
    "10€ Gutschein"
  ];
  function prizeFor(rankIdx){ return PRIZES[rankIdx] || "einen exklusiven Gutschein"; }

  if (window.__flicksGameLoaded) return;
  window.__flicksGameLoaded = true;

  /* ---------- Booster-Item-Bild (echtes Foto statt gezeichneter Form) ---------- */
  var BOOSTER_IMG_URL = "https://cdn.shopify.com/s/files/1/1001/5794/8288/files/flicks-booster-item.png";
  var boosterImg = new Image();
  var boosterImgReady = false;
  boosterImg.onload = function(){ boosterImgReady = true; };
  boosterImg.src = BOOSTER_IMG_URL;
  var BOOSTER_AR = 478/630; // Breite/Hoehe des Fotos, fuer korrekte Proportionen beim Zeichnen

  /* ---------- Logo-Wasserzeichen im Spielhintergrund (dreht sich um die eigene Achse) ---------- */
  var LOGO_IMG_URL = "https://cdn.shopify.com/s/files/1/1001/5794/8288/files/logoPNG.png?v=1784451927"; // echtes Header-Logo mit transparentem Hintergrund (nicht das og:image mit weissem BG!)
  var logoImg = new Image();
  var logoImgReady = false;
  logoImg.onload = function(){ logoImgReady = true; };
  logoImg.src = LOGO_IMG_URL;

  /* ---------- Styles ---------- */
  var css = document.createElement("style");
  css.textContent = [
    "#flx-trigger{position:fixed;right:16px;bottom:16px;z-index:99998;background:" + BRAND + ";color:#fff;border:none;border-radius:999px;padding:12px 18px;font:600 14px/1 system-ui,sans-serif;cursor:pointer;box-shadow:0 6px 20px rgba(0,0,0,.35);transition:transform .15s}",
    "#flx-trigger:hover{transform:translateY(-2px) scale(1.03)}",
    "#flx-overlay{position:fixed;inset:0;z-index:99999;background:rgba(10,0,0,.82);backdrop-filter:blur(4px);display:none;align-items:center;justify-content:center;font-family:system-ui,-apple-system,sans-serif}",
    "#flx-overlay.open{display:flex}",
    ".flx-modal{width:min(94vw,420px);background:linear-gradient(160deg," + BRAND_DK + "," + BRAND + ");border:2px solid " + BRAND_LT + ";border-radius:18px;padding:18px;color:#fff;box-shadow:0 20px 60px rgba(0,0,0,.6);position:relative}",
    ".flx-close{position:absolute;top:10px;right:12px;background:none;border:none;color:" + BRAND_LT + ";font-size:26px;line-height:1;cursor:pointer}",
    ".flx-title{margin:0 0 2px;font-size:22px;font-weight:800;letter-spacing:.5px}",
    ".flx-sub{margin:0 0 12px;font-size:12px;color:" + BRAND_LT + ";opacity:.9}",
    ".flx-canvas-wrap{position:relative;border-radius:12px;overflow:hidden;background:#1a0505;border:1px solid rgba(249,175,174,.3)}",
    "#flx-canvas{display:block;width:100%;height:auto;touch-action:none}",
    ".flx-hud{position:absolute;top:8px;left:10px;right:10px;display:flex;justify-content:space-between;font-weight:700;font-size:14px;text-shadow:0 1px 3px #000;pointer-events:none}",
    ".flx-btn{display:inline-block;background:" + GOLD + ";color:" + BRAND_DK + ";border:none;border-radius:10px;padding:11px 16px;font-weight:800;font-size:15px;cursor:pointer;transition:transform .12s;width:100%}",
    ".flx-btn:hover{transform:translateY(-1px)}",
    ".flx-btn.sec{background:transparent;color:#fff;border:1px solid " + BRAND_LT + "}",
    ".flx-center{text-align:center}",
    ".flx-lb{list-style:none;margin:10px 0;padding:0;max-height:220px;overflow:auto;scroll-behavior:smooth}",
    ".flx-lb-count{margin:0 0 6px;text-align:center}",
    ".flx-my-rank{margin-top:8px}",
    ".flx-lb li{display:flex;justify-content:space-between;padding:6px 10px;border-radius:8px;font-size:14px}",
    ".flx-lb li:nth-child(odd){background:rgba(255,255,255,.07)}",
    ".flx-lb .rank{color:" + GOLD + ";font-weight:800;width:26px}",
    ".flx-lb .nm{flex:1;text-align:left;padding-left:6px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}",
    ".flx-lb .sc{font-weight:800}",
    ".flx-field{width:100%;box-sizing:border-box;padding:11px 12px;border-radius:9px;border:1px solid " + BRAND_LT + ";background:rgba(255,255,255,.95);color:#111;font-size:15px;margin:6px 0}",
    ".flx-hint{background:rgba(246,213,92,.15);border:1px solid " + GOLD + ";border-radius:10px;padding:9px 12px;font-size:12.5px;margin:10px 0;line-height:1.4}",
    ".flx-hint b{color:" + GOLD + "}",
    ".flx-prize-list{list-style:none;margin:6px 0 0;padding:0}",
    ".flx-prize-list li{padding:3px 0;border-top:1px solid rgba(246,213,92,.25)}",
    ".flx-prize-list li:first-child{border-top:none}",
    ".flx-prize-list b{color:" + GOLD + ";margin-right:4px}",
    ".flx-row{display:flex;gap:8px;margin-top:8px}",
    ".flx-row .flx-btn{width:auto;flex:1}",
    ".flx-msg{font-size:13px;text-align:center;margin-top:8px;min-height:16px}",
    /* 2026-08-08 (Philip): Logo soll sich nicht mehr wie eine flache Karte
       drehen, sondern wie ein "dickeres", massives 3D-Objekt um die eigene
       Achse. Trick: mehrere Kopien desselben Logo-Bilds werden im JS unten
       hintereinander gestapelt (translateZ, jede Schicht etwas dunkler) statt
       nur eine einzelne flache Ebene zu drehen - beim Vorbeidrehen sieht man
       dadurch eine "Kante" aus mehreren Lagen statt nur eine duenne Linie. */
    ".flx-logo-3d-wrap{display:block;width:100%;perspective:6000px;cursor:pointer;margin-bottom:56px !important;position:relative;z-index:1}",
    ".flx-logo-3d-spin{display:block;width:100%;height:100%;position:relative;transform-style:preserve-3d;animation:flxSpinLogo3d 9s linear infinite;will-change:transform}",
    ".flx-logo-3d-wrap:hover .flx-logo-3d-spin{animation-duration:2.4s}",
    "@keyframes flxSpinLogo3d{0%{transform:rotateY(0deg)}100%{transform:rotateY(360deg)}}",
    ".flx-logo-3d-layer{transform:translateZ(var(--z,0px))}",
    ".flx-logo-3d-layer--clone{position:absolute;inset:0;width:100%;height:100%;pointer-events:none}",
    "@media (prefers-reduced-motion: reduce){.flx-logo-3d-spin{animation:none}}",
    ".flx-logo-hint{position:fixed;left:50%;top:0;transform:translate(-50%,0);z-index:99997;font:600 12px/1.2 system-ui,-apple-system,sans-serif;color:" + BRAND + ";background:rgba(255,255,255,.85);border:1px solid " + BRAND_LT + ";border-radius:999px;padding:5px 12px;cursor:pointer;opacity:0;white-space:nowrap;box-shadow:0 2px 10px rgba(61,1,0,.16);animation:flxHintIn .7s ease 1.2s forwards, flxHintBob 2.8s ease-in-out 1.9s infinite;pointer-events:auto}",
    ".flx-logo-hint:hover{background:#fff;color:" + BRAND_DK + "}",
    "@keyframes flxHintIn{to{opacity:.92}}",
    "@keyframes flxHintBob{0%,100%{transform:translate(-50%,0)}50%{transform:translate(-50%,-3px)}}",
    "@media (prefers-reduced-motion: reduce){.flx-logo-hint{animation:flxHintIn .7s ease 1.2s forwards;transform:translate(-50%,0)}}"
  ].join("");
  document.head.appendChild(css);

  /* ---------- DOM ---------- */
  var trigger = document.createElement("button");
  trigger.id = "flx-trigger";
  trigger.type = "button";
  trigger.innerHTML = "🎮 Mini-Game";
  var overlay = document.createElement("div");
  overlay.id = "flx-overlay";
  overlay.innerHTML = '<div class="flx-modal"><button class="flx-close" aria-label="Schließen">×</button><div id="flx-body"></div></div>';

  function ready(fn){ if(document.readyState!=="loading") fn(); else document.addEventListener("DOMContentLoaded",fn); }
  ready(function(){
    document.body.appendChild(trigger);
    document.body.appendChild(overlay);
    // Easter-Egg: Logo klickbar machen + als gestapeltes "dickeres" 3D-Objekt
    // um die eigene Achse drehen lassen (2026-08-08, Philip). Statt nur EINE
    // flache Bild-Ebene zu drehen, wird das Logo-Bild mehrfach als Kopie
    // hintereinander gestapelt (translateZ + zunehmend dunkler) - beim
    // Vorbeidrehen zeigt sich dadurch eine echte "Kante" aus mehreren Lagen
    // statt nur einer duennen Linie, wirkt also wie ein massives Objekt.
    var logos = document.querySelectorAll('img[src*="logo" i], [class*="logo" i] img, .password-logo, header img');
    var logoWraps = [];
    logos.forEach(function(el){
      var wrap = document.createElement("div");
      wrap.className = "flx-logo-3d-wrap";
      wrap.title = "🎮 Klick mich!";
      var spin = document.createElement("div");
      spin.className = "flx-logo-3d-spin";
      // Feste Seitenverhaeltnis-Vorgabe statt height:100% - sonst haengt die
      // Hoehe vom umgebenden Flex-Layout ab und geraet bei den absolut
      // positionierten Stapel-Kopien leicht aus dem Takt (wurde per Playwright
      // gemessen: Kopien landeten ~56px hoeher als das Original -> sichtbares
      // "Geisterbild"/doppelter Text beim Drehen). Mit aspect-ratio bekommen
      // Original UND alle Kopien garantiert exakt dieselbe Box.
      var iw = parseFloat(el.getAttribute("width")) || el.naturalWidth || 1;
      var ih = parseFloat(el.getAttribute("height")) || el.naturalHeight || 1;
      wrap.style.aspectRatio = iw + " / " + ih;
      el.parentNode.insertBefore(wrap, el);
      wrap.appendChild(spin);
      spin.appendChild(el);
      el.classList.add("flx-logo-3d-layer");
      // 2026-08-08 (Philip, 2. Feedback-Runde): mit nur 9 Lagen (Abstand 2.2px)
      // waren beim seitlichen Drehen einzelne Luecken zwischen den Schichten
      // sichtbar ("Jalousie"-Effekt statt einer massiven Kante). Mehr Lagen
      // allein reichten nicht ganz - die farbig/detailreichen Kopien (Text,
      // Farbverlaeufe im Bild) erzeugten beim Uebereinanderlegen ein feines
      // Moire-Gewebe-Muster. Fix: NUR die vorderste Lage (Original) bleibt
      // farbig/scharf - alle dahinterliegenden "Tiefen"-Lagen werden per
      // Filter zu einer FLACHEN, einfarbigen Silhouette reduziert (keine
      // internen Farben/Kanten mehr, die Moire verursachen koennten) - wie
      // die einfarbig schattierte Seitenflaeche eines echten extrudierten
      // Objekts. Plus viele duenne Lagen (44, Gesamttiefe ~20px, Abstand
      // < 0.5px im Kantenblick), damit auch die Silhouetten-Aussenkante
      // luecken-/stufenlos ineinander uebergeht.
      // 2026-08-08 (Philip, 3. Feedback-Runde): mit ALLEN hinteren Lagen
      // schwarz eingefaerbt war die Rueckseite (~180°) komplett farblos -
      // wirkte wie eine leere/kaputte Stelle. Fix: die HINTERSTE Lage bleibt
      // (wie die vorderste) unveraendert farbig - sie ist die "Rueckseite"
      // des Objekts. Nur die Lagen DAZWISCHEN (der Rand/die "Kante") bleiben
      // einfarbig schwarz, um das Moire-Problem von oben weiter zu vermeiden.
      var LOGO_LAYERS = 44, LOGO_DEPTH = 20;
      var LOGO_STEP = LOGO_DEPTH / (LOGO_LAYERS - 1);
      for (var i = 1; i < LOGO_LAYERS; i++) {
        var clone = el.cloneNode(false);
        clone.removeAttribute("id");
        clone.classList.add("flx-logo-3d-layer--clone");
        clone.style.setProperty("--z", (-i * LOGO_STEP).toFixed(2) + "px");
        var isBackFace = (i === LOGO_LAYERS - 1);
        if (!isBackFace) {
          clone.style.filter = "brightness(0) opacity(.88)";
        }
        clone.setAttribute("alt", "");
        clone.setAttribute("aria-hidden", "true");
        spin.appendChild(clone);
      }
      wrap.addEventListener("click", function(e){ e.preventDefault(); openGame(); });
      logoWraps.push(wrap);
    });
    if (logoWraps.length) {
      var hint = document.createElement("span");
      hint.className = "flx-logo-hint";
      hint.textContent = "Psst … tipp mal aufs Logo";
      hint.addEventListener("click", function(e){ e.preventDefault(); openGame(); });
      document.body.appendChild(hint);
      var placeHint = function(){
        var r = logoWraps[0].getBoundingClientRect();
        if (r.width === 0) return;
        hint.style.left = (r.left + r.width/2) + "px";
        hint.style.top = (r.bottom + 8) + "px";
      };
      placeHint();
      window.addEventListener("resize", placeHint);
      window.addEventListener("scroll", placeHint, { passive:true });
      setTimeout(placeHint, 400); setTimeout(placeHint, 1200);
    }
  });

  var body = function(){ return document.getElementById("flx-body"); };
  overlay.addEventListener("click", function(e){ if(e.target===overlay) closeGame(); });
  overlay.querySelector(".flx-close").addEventListener("click", closeGame);
  trigger.addEventListener("click", openGame);

  function openGame(){ overlay.classList.add("open"); showFrozen(); }
  function closeGame(){ overlay.classList.remove("open"); stopLoop(); }

  /* 2026-09-01 (Philip, 16:00 Uhr): Aktion beendet, Minigame nicht mehr
     spielbar - Logo-Klick/Floating-Button zeigen nur noch die (eingefrorene)
     Rangliste zum aktuellen Stand. showStart()/startGame() bleiben als
     toter Code stehen (falls Philip das Spiel je reaktivieren will),
     werden aber nicht mehr aufgerufen. Leaderboard/Formspree/JSONBin-Logik
     komplett unangetastet. */
  function showFrozen(){
    body().innerHTML =
      '<h2 class="flx-title">BOOSTER CATCH</h2>'+
      '<p class="flx-sub">Die Aktion ist beendet.</p>'+
      '<div id="flx-lb-box">'+lbHtml(-1)+'</div>';
    fetchRemote(function(){ var box=document.getElementById("flx-lb-box"); if(box) box.innerHTML=lbHtml(-1); });
  }

  /* ---------- Leaderboard ---------- */
  function getLB(){ try{ return JSON.parse(localStorage.getItem(LB_KEY))||[]; }catch(e){ return []; } }
  function saveLB(lb){ try{ localStorage.setItem(LB_KEY, JSON.stringify(lb.slice(0,MAX_STORE))); }catch(e){} }
  function addScore(name, score){ var e={n:name,s:score,t:Date.now()}; var lb=getLB(); lb.push(e); lb.sort(function(a,b){return b.s-a.s;}); lb=lb.slice(0,MAX_STORE); saveLB(lb); pushRemote(e); return lb; }
  function rankOf(score){ var lb=getLB(); var r=1; for(var i=0;i<lb.length;i++){ if(score<lb[i].s) r++; } return r; }
  // ----- Globales Leaderboard (JSONBin) -----
  function cacheLB(sc){ try{ localStorage.setItem(LB_KEY, JSON.stringify(sc.slice(0,MAX_STORE))); }catch(e){} }
  function fetchRemote(cb){
    fetch(BIN_URL+"/latest",{headers:{"X-Access-Key":BIN_KEY}})
      .then(function(r){ return r.ok?r.json():null; })
      .then(function(d){ var sc=(d&&d.record&&d.record.scores)?d.record.scores:null; if(sc){ sc.sort(function(a,b){return b.s-a.s;}); cacheLB(sc); } if(cb) cb(sc); })
      .catch(function(){ if(cb) cb(null); });
  }
  function pushRemote(entry){
    fetchRemote(function(sc){
      var lb=(sc||getLB()).slice(); lb.push(entry); lb.sort(function(a,b){return b.s-a.s;}); lb=lb.slice(0,MAX_STORE);
      fetch(BIN_URL,{method:"PUT",headers:{"Content-Type":"application/json","X-Access-Key":BIN_KEY},body:JSON.stringify({scores:lb})})
        .then(function(r){ if(r.ok){ cacheLB(lb); } }).catch(function(){});
    });
  }

  function lbHtml(highlightIdx){
    var lb=getLB();
    if(!lb.length) return '<p class="flx-sub flx-center">Noch keine Scores – sei der Erste!</p>';
    var h='<p class="flx-sub flx-lb-count">🏅 '+lb.length+' Teilnehmer insgesamt</p>';
    h+='<ol class="flx-lb" id="flx-lb-list">';
    for(var i=0;i<lb.length;i++){
      var medal = i===0?"🥇":i===1?"🥈":i===2?"🥉":(i+1);
      var isMe = i===highlightIdx;
      h+='<li'+(isMe?' id="flx-me" style="outline:2px solid '+GOLD+'"':'')+'><span class="rank">'+medal+'</span><span class="nm">'+esc(lb[i].n)+'</span><span class="sc">'+lb[i].s+'</span></li>';
    }
    h+='</ol>';
    if(highlightIdx>-1){
      h+='<p class="flx-sub flx-center flx-my-rank">📍 Dein Platz: <b style="color:'+GOLD+'">#'+(highlightIdx+1)+'</b> von '+lb.length+'</p>';
    }
    return h;
  }
  function scrollToMe(){ var el=document.getElementById("flx-me"); if(el && el.scrollIntoView){ el.scrollIntoView({block:"center", behavior:"smooth"}); } }
  function esc(s){ return String(s).replace(/[<>&"]/g,function(c){return{"<":"&lt;",">":"&gt;","&":"&amp;",'"':"&quot;"}[c];}); }

  /* ---------- Screens ---------- */
  function showStart(){
    body().innerHTML =
      '<h2 class="flx-title">BOOSTER CATCH</h2>'+
      '<p class="flx-sub">Fang die Booster mit dem Einkaufswagen. Weiche den blauen Flammen aus. 45 Sekunden – wie viele schaffst du?</p>'+
      '<p class="flx-sub" style="margin-top:-4px">⏰ Aktion endet am <b style="color:'+GOLD+'">01.09.2026, 16:00 Uhr</b>.</p>'+
      '<div class="flx-hint flx-prizes">🏆 <b>Preise für Top 1–5:</b>'+
        '<ul class="flx-prize-list">'+
          '<li><b>#1</b> '+PRIZES[0]+'</li>'+
          '<li><b>#2</b> '+PRIZES[1]+'</li>'+
          '<li><b>#3</b> '+PRIZES[2]+'</li>'+
          '<li><b>#4</b> '+PRIZES[3]+'</li>'+
          '<li><b>#5</b> '+PRIZES[4]+'</li>'+
        '</ul>'+
      '</div>'+
      '<div id="flx-lb-box">'+lbHtml(-1)+'</div>'+
      '<button class="flx-btn" id="flx-play">▶ Spielen</button>'+
      '<div class="flx-row"><button class="flx-btn sec" id="flx-how">Steuerung</button></div>'+
      '<div class="flx-msg" id="flx-how-msg"></div>';
    document.getElementById("flx-play").onclick = startGame;
    fetchRemote(function(){ var box=document.getElementById("flx-lb-box"); if(box) box.innerHTML=lbHtml(-1); });
    document.getElementById("flx-how").onclick = function(){ document.getElementById("flx-how-msg").textContent="Maus/Finger bewegen oder ← → Pfeiltasten."; };
  }

  /* ---------- Game ---------- */
  var W=360,H=480,canvas,ctx,raf,state;
  function startGame(){
    body().innerHTML =
      '<div class="flx-canvas-wrap"><div class="flx-hud"><span id="flx-score">0</span><span id="flx-lives">❤❤❤</span><span id="flx-time">45</span></div>'+
      '<canvas id="flx-canvas" width="'+W+'" height="'+H+'"></canvas></div>';
    canvas=document.getElementById("flx-canvas"); ctx=canvas.getContext("2d");
    state={ x:W/2, score:0, lives:3, t:45, items:[], spawn:0, speed:1, combo:0, last:performance.now(), tRemain:45, over:false, logoAngle:0 };
    bindInput();
    stopLoop(); loop(state.last);
    clearInterval(state.timer);
    state.timer=setInterval(function(){
      state.tRemain--; var te=document.getElementById("flx-time"); if(te) te.textContent=Math.max(0,state.tRemain);
      state.speed=1+ (45-state.tRemain)*0.085;
      if(state.tRemain<=0) endGame();
    },1000);
  }
  function bindInput(){
    function move(clientX){ var r=canvas.getBoundingClientRect(); state.x=Math.max(24,Math.min(W-24,(clientX-r.left)*(W/r.width))); }
    canvas.onmousemove=function(e){ move(e.clientX); };
    canvas.ontouchmove=function(e){ e.preventDefault(); move(e.touches[0].clientX); };
    document.onkeydown=function(e){ if(!state||state.over) return; if(e.key==="ArrowLeft") state.x=Math.max(24,state.x-28); if(e.key==="ArrowRight") state.x=Math.min(W-24,state.x+28); };
  }
  function spawn(){
    var r=Math.random(); var type = r<0.30 ? "fire" : (r<0.36 ? "shiny" : "booster");
    var drift = (Math.random()-0.5) * (0.6 + (45-state.tRemain)*0.03);
    state.items.push({ x:24+Math.random()*(W-48), y:-24, type:type, vy:(2.9+Math.random()*2.0)*state.speed, vx:drift, rot:Math.random()*6 });
  }
  function loop(now){
    if(!state||state.over) return;
    var dt=Math.min(40, now-state.last); state.last=now;
    state.spawn-=dt; if(state.spawn<=0){ spawn(); state.spawn=Math.max(200, 560-(45-state.tRemain)*12); }
    ctx.clearRect(0,0,W,H);
    // bg
    var g=ctx.createLinearGradient(0,0,0,H); g.addColorStop(0,"#2a0808"); g.addColorStop(1,"#1a0505"); ctx.fillStyle=g; ctx.fillRect(0,0,W,H);
    // Logo-Wasserzeichen, dreht sich langsam um die eigene Achse (pseudo-3D per Skalierung)
    state.logoAngle += dt*0.0011;
    if(logoImgReady){
      ctx.save();
      ctx.globalAlpha=0.22;
      ctx.translate(W/2,H/2);
      ctx.scale(Math.cos(state.logoAngle),1);
      var ls=200;
      ctx.drawImage(logoImg,-ls/2,-ls/2,ls,ls);
      ctx.restore();
    }
    // items
    for(var i=state.items.length-1;i>=0;i--){
      var it=state.items[i]; it.y+=it.vy*(dt/16); it.x+=(it.vx||0)*(dt/16); it.rot+=0.04;
      if(it.x<16){it.x=16;it.vx=Math.abs(it.vx||0);} if(it.x>W-16){it.x=W-16;it.vx=-Math.abs(it.vx||0);}
      drawItem(it);
      // catch check (enge Fangzone)
      if(it.y> H-56 && Math.abs(it.x-state.x)<24){
        if(it.type==="fire"){ hit(); }
        else { var pts = it.type==="shiny"?5:1; state.combo++; state.score += pts*(1+Math.floor(state.combo/8)); flash(it.x,it.y,it.type==="shiny"?GOLD:BRAND_LT); }
        state.items.splice(i,1); updateHud(); continue;
      }
      if(it.y>H+24){ if(it.type==="booster"||it.type==="shiny"){ state.combo=0; } state.items.splice(i,1); }
    }
    drawPaddle();
    drawFlashes(dt);
    raf=requestAnimationFrame(loop);
  }
  function hit(){ state.lives--; state.combo=0; updateHud(); shake(); if(state.lives<=0) endGame(); }
  function updateHud(){ var s=document.getElementById("flx-score"), l=document.getElementById("flx-lives"); if(s)s.textContent=state.score; if(l)l.textContent="❤❤❤❤❤".slice(0,Math.max(0,state.lives)) + "♡♡♡♡♡".slice(0,Math.max(0,3-state.lives)); }
  function drawItem(it){
    ctx.save(); ctx.translate(it.x,it.y); ctx.rotate(Math.sin(it.rot)*0.15);
    if(it.type==="fire"){ ctx.shadowColor="#38bdf8"; ctx.shadowBlur=14; ctx.fillStyle="#1e90ff"; ctx.beginPath(); ctx.moveTo(0,-16); ctx.bezierCurveTo(11,-3,11,8,0,16); ctx.bezierCurveTo(-11,8,-11,-3,0,-16); ctx.closePath(); ctx.fill(); ctx.shadowBlur=0; ctx.fillStyle="#cdf3ff"; ctx.beginPath(); ctx.moveTo(0,-5); ctx.bezierCurveTo(6,1,6,8,0,12); ctx.bezierCurveTo(-6,8,-6,1,0,-5); ctx.closePath(); ctx.fill(); }
    else if(it.type==="shiny"){ // Glitzerstern (Vektor statt Emoji - Canvas-Emoji ist auf manchen mobilen Webviews unsichtbar)
      ctx.fillStyle=GOLD; ctx.shadowColor=GOLD; ctx.shadowBlur=9;
      sparkle(0,0,11,3.2); sparkle(7,-7,5,1.6);
      ctx.shadowBlur=0;
    }
    else if(boosterImgReady){ // echtes Booster-Pack-Foto
      var bh=38, bw=bh*BOOSTER_AR;
      ctx.drawImage(boosterImg, -bw/2, -bh/2, bw, bh);
    }
    else { // Fallback (gezeichnete Form), solange das Foto noch laedt
      ctx.fillStyle=BRAND; ctx.strokeStyle=BRAND_LT; ctx.lineWidth=2;
      roundRect(-13,-18,26,36,4); ctx.fill(); ctx.stroke();
      ctx.fillStyle=GOLD; roundRect(-13,-6,26,5,1); ctx.fill();
      ctx.fillStyle=BRAND_LT; ctx.font="9px system-ui"; ctx.textAlign="center"; ctx.fillText("F",0,-9);
    }
    ctx.restore();
  }
  function drawPaddle(){
    ctx.save(); ctx.translate(state.x,H-40);
    // Einkaufswagen (als Vektor-Form gezeichnet, nicht als Emoji -> zeigt garantiert gleich auf jedem Geraet/Browser,
    // Emoji-Rendering in Canvas ist auf manchen mobilen Webviews unzuverlaessig/unsichtbar)
    ctx.lineJoin="round"; ctx.lineCap="round";
    // Korb (Trapez)
    ctx.beginPath();
    ctx.moveTo(-17,-11); ctx.lineTo(15,-11); ctx.lineTo(9,11); ctx.lineTo(-11,11); ctx.closePath();
    ctx.fillStyle=BRAND_LT; ctx.fill();
    ctx.strokeStyle="#fff"; ctx.lineWidth=2.5; ctx.stroke();
    // Gitterlinien im Korb
    ctx.strokeStyle="rgba(61,1,0,.35)"; ctx.lineWidth=1.2;
    ctx.beginPath(); ctx.moveTo(-13,-4); ctx.lineTo(12,-4); ctx.moveTo(-12,3); ctx.lineTo(10,3); ctx.stroke();
    // Griff
    ctx.strokeStyle="#fff"; ctx.lineWidth=2.5;
    ctx.beginPath(); ctx.moveTo(-17,-11); ctx.lineTo(-23,-22); ctx.lineTo(-14,-22); ctx.stroke();
    // Raeder
    ctx.fillStyle="#222";
    ctx.beginPath(); ctx.arc(-8,16,3.4,0,Math.PI*2); ctx.fill();
    ctx.beginPath(); ctx.arc(6,16,3.4,0,Math.PI*2); ctx.fill();
    ctx.restore();
  }
  var flashes=[];
  function flash(x,y,c){ flashes.push({x:x,y:y,c:c,life:1}); }
  function drawFlashes(dt){ for(var i=flashes.length-1;i>=0;i--){ var f=flashes[i]; f.life-=dt/450; if(f.life<=0){ flashes.splice(i,1); continue; } ctx.save(); ctx.globalAlpha=f.life; ctx.strokeStyle=f.c; ctx.lineWidth=3; ctx.beginPath(); ctx.arc(f.x,f.y,(1-f.life)*26+6,0,Math.PI*2); ctx.stroke(); ctx.restore(); } }
  function shake(){ canvas.style.transform="translateX(-6px)"; setTimeout(function(){ if(canvas) canvas.style.transform="translateX(6px)"; },60); setTimeout(function(){ if(canvas) canvas.style.transform=""; },120); }
  function roundRect(x,y,w,h,r){ ctx.beginPath(); ctx.moveTo(x+r,y); ctx.arcTo(x+w,y,x+w,y+h,r); ctx.arcTo(x+w,y+h,x,y+h,r); ctx.arcTo(x,y+h,x,y,r); ctx.arcTo(x,y,x+w,y,r); ctx.closePath(); }
  var SPARKLE_PTS=[[0,-1],[0.35,-0.35],[1,0],[0.35,0.35],[0,1],[-0.35,0.35],[-1,0],[-0.35,-0.35]];
  function sparkle(cx,cy,outerR,innerR){
    ctx.beginPath();
    for (var i=0;i<SPARKLE_PTS.length;i++){
      var r = (i%2===0)?outerR:innerR;
      var px = cx+SPARKLE_PTS[i][0]*r, py = cy+SPARKLE_PTS[i][1]*r;
      if(i===0) ctx.moveTo(px,py); else ctx.lineTo(px,py);
    }
    ctx.closePath(); ctx.fill();
  }
  function stopLoop(){ if(raf) cancelAnimationFrame(raf); if(state&&state.timer) clearInterval(state.timer); }

  function endGame(){
    if(state.over) return; state.over=true; stopLoop(); document.onkeydown=null;
    showGameOver(state.score);
  }

  /* ---------- Game Over / Submit ---------- */
  function showGameOver(score){
    var willRank = rankOf(score);
    var top5 = willRank<=5;
    body().innerHTML =
      '<h2 class="flx-title flx-center">GAME OVER</h2>'+
      '<p class="flx-sub flx-center">Dein Score: <b style="color:'+GOLD+';font-size:20px">'+score+'</b></p>'+
      '<p class="flx-sub flx-center">📅 Die Ergebnisse werden am <b>01.09.</b> ausgewertet – Gutscheine werden danach versendet.</p>'+
      '<input class="flx-field" id="flx-name" maxlength="16" placeholder="Dein Name fürs Leaderboard">'+
      '<button class="flx-btn" id="flx-save">Ins Leaderboard eintragen</button>'+
      '<div id="flx-after"></div>'+
      '<div class="flx-row"><button class="flx-btn sec" id="flx-again">Nochmal</button></div>';
    document.getElementById("flx-again").onclick = startGame;
    document.getElementById("flx-save").onclick = function(){
      var nm=(document.getElementById("flx-name").value||"Anonym").trim().slice(0,16);
      var lb=addScore(nm,score);
      var idx=-1; for(var i=0;i<lb.length;i++){ if(lb[i].n===nm && lb[i].s===score){ idx=i; break; } }
      var after=document.getElementById("flx-after");
      after.innerHTML = lbHtml(idx);
      scrollToMe();
      if(idx>-1 && idx<5){
        after.innerHTML +=
          '<div class="flx-hint">🎉 <b>Aktuell Platz '+(idx+1)+'!</b> Dein Preis: <b>'+prizeFor(idx)+'</b>. Bleibst du bis zum Ende der Aktion in den Top 5, meldet sich FLICK-S <b>per Mail</b>. Trag deine E-Mail ein, um dabei zu sein.</div>'+
          '<input class="flx-field" id="flx-email" type="email" placeholder="deine@email.de">'+
          '<button class="flx-btn" id="flx-submit">Am Gewinnspiel teilnehmen</button>'+
          '<div class="flx-msg" id="flx-submsg"></div>';
        document.getElementById("flx-submit").onclick = function(){ submitScore(nm, score, idx+1); };
      } else {
        after.innerHTML += '<p class="flx-sub flx-center" style="margin-top:8px">Knapp! Die Top 5 bekommen tolle Preise (bis zu 3x 151 Einzelbooster (Japanisch) + 50€) – probier\'s nochmal. 💪</p>';
      }
      document.getElementById("flx-save").disabled=true; document.getElementById("flx-save").style.opacity=.5;
    };
  }

  function submitScore(name, score, rank){
    var emailEl=document.getElementById("flx-email"); var email=(emailEl.value||"").trim();
    var msg=document.getElementById("flx-submsg");
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){ msg.style.color="#ffd2d2"; msg.textContent="Bitte gültige E-Mail eingeben."; return; }
    // Lokale Sicherung aller Einreichungen (Backup)
    try{ var subs=JSON.parse(localStorage.getItem("flicks_submissions")||"[]"); subs.push({name:name,email:email,score:score,rank:rank,t:new Date().toISOString()}); localStorage.setItem("flicks_submissions",JSON.stringify(subs)); }catch(e){}
    msg.style.color="#c9ffcf"; msg.textContent="Wird gesendet…";
    var submitBtn=document.getElementById("flx-submit"); if(submitBtn) submitBtn.disabled=true;
    var when=new Date().toLocaleString();
    var bodyText = "GEWINNSPIEL 'Booster Catch' - neuer Top-Score!\n\n"
      + "Username: " + name + "\nScore: " + score + "\nPlatzierung: Top " + rank
      + "\nSpieler-E-Mail: " + email + "\nZeitpunkt: " + when;
    var payload = { _subject:"FLICK-S Gewinnspiel - "+name+" ("+score+")", Spiel:"Booster Catch",
      Username:name, Score:score, Platzierung:"Top "+rank, Spieler_Email:email, Zeitpunkt:when };
    // 1) Formspree (falls konfiguriert) - funktioniert auch hinter Passwortschutz
    if (FORM_ENDPOINT) {
      fetch(FORM_ENDPOINT, { method:"POST", headers:{"Content-Type":"application/json","Accept":"application/json"}, body: JSON.stringify(payload) })
        .then(function(r){ if(r.ok){ done(); } else { tryContact(); } })
        .catch(function(){ tryContact(); });
    } else { tryContact(); }
    // 2) Natives Shopify-Kontaktformular (greift, sobald der Shop LIVE ist)
    function tryContact(){
      var params = new URLSearchParams();
      params.append("form_type","contact"); params.append("utf8","✓");
      params.append("contact[email]", email); params.append("contact[body]", bodyText);
      fetch("/contact", { method:"POST", headers:{"Content-Type":"application/x-www-form-urlencoded"}, body: params.toString() })
        .then(function(){ done(); }).catch(function(){ fallbackMail(); });
    }
    function done(){ msg.style.color="#c9ffcf"; msg.textContent="✅ Abgeschickt! Bleibst du bis zum Ende der Aktion in den Top 5, meldet sich FLICK-S per Mail mit deinem Preis."; emailEl.disabled=true; }
    function fallbackMail(){
      var subj=encodeURIComponent("FLICK-S Gewinnspiel Score - "+name+" ("+score+")");
      window.location.href="mailto:"+FALLBACK_EMAIL+"?subject="+subj+"&body="+encodeURIComponent(bodyText);
      done();
    }
  }
})();










